export enum StyleEnum {
  BITSTRIPS = 1,
  BITMOJI = 4,
  CM = 5,
}
